import React, { useEffect, useRef, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";
import { withSnackbar } from "notistack";

import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";
import RadioBtn from "components/Custom/RadioBtn";
import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";
import UiDialog from "components/Custom/UiDialog";

import { COMMON_JS } from "common/scripts";
import { DEFAULTS, NOTIFY } from "common/config";
import { DateFunctions } from "common/datefunctions";
import { COLORS } from "common/colors";
import {
  ERRORS,
  LABELS,
  SUB_TITLES,
  SUCCESS,
  TITLES,
  WARNINGS,
} from "common/lables";

import { MASTER_APIs } from "apihandlers/master";
import { USER_APIs } from "apihandlers/user";

const TaskAssignment = (props: any) => {
  const { setDashMenu } = props;

  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [gridLoading, setGridLoading] = useState(true);

  const [isSubmit, setIsSubmit] = useState(false);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [mandatoryLoadResults, setMandatoryLoadResults] = useState<any[]>([]);
  const [users, setUsers] = useState([]);

  const usersRef: any = useRef(null);

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      type: "number",
      width: "5%",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "assignedTo",
      name: LABELS.ASSIGNED_TO,
      width: "45%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "taskName",
      name: LABELS.TASK_NAMES,
      width: "35%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },

    {
      key: "activeStatus",
      name: LABELS.ACTIVE,
      width: "10%",
      editable: false,
      sortable: true,
      align: "center",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      searchable: true,
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      type: "text",
      width: "5%",
      editable: false,
      sortable: true,
      align: "left",
      renderCell: ({ row }: any) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton className="iconBtn" onClick={() => onEditRow(row)}>
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    USER_APIs.getUsers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.fullName,
          };
        });
        setUsers(list);
        // getRows();
      }
    });
  };
  // const getRows = () => {
  //   const args = {
  //     pageNo: 1,
  //     pageLength: DEFAULTS.PAGE_LENGTH,
  //   };
  //   MASTER_APIs.getVehicleChecks(args).then((res: any) => {
  //     const response: any = res.response;
  //     const { status } = res;
  //     if (status === 200) {
  //       let list = response.records;
  //       for (let i = 0; i < list.length; i++) {
  //         list[i]["slNo"] = i + 1;
  //         if (list[i]["activeStatus"]) {
  //           list[i]["activeStatus"] = "Yes";
  //         } else {
  //           list[i]["activeStatus"] = "No";
  //         }
  //       }
  //       setRows(list);
  //       setLoading(false);
  //     }
  //   });
  // };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
  };

  const reloadGrid = () => {
    setRows(null);
    loadGrid();
  };

  const loadGrid = () => {
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    let loadErrors = [];

    if (fromDt === "") {
      loadErrors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt === "") {
      loadErrors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setGridLoading(false);
    setMandatoryLoadResults(loadErrors);
    if (loadErrors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }
    const args = {
      fromDt,
      toDt,
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };
    setLoading(true);
    setGridLoading(false);

    MASTER_APIs.getTasks(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    });
  };
  const manageRecord = () => {
    const assignedToId = usersRef.current.selectedValue.id;
    const taskName = (
      document.getElementById("taskName") as HTMLInputElement
    ).value.trim();
    let ele = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = ele ? ele.value : "";
    //todo:Validations needs to be done

    // Validations;
    let errors = [];
    if (!assignedToId) {
      errors.push({
        id: "assignedToId",
        msg:
          "<span class='bold'>" +
          LABELS.ASSIGNED_TO +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (taskName === "") {
      errors.push({
        id: "taskName",
        msg:
          "<span class='bold'>" +
          LABELS.TASK_NAMES +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      assignedById: 3,
      assignedDate: "",
      assignedToId,
      taskName,
      activeStatus,
    };
    console.log("args", args);
    setIsSubmit(true);
    MASTER_APIs.manageTask(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  console.log("Page: Country:");

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>
            {LABELS.TRANSACTION}{" "}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.TASK_ASSIGNMENT}</li>
        </ul>
        <h4>{TITLES.TASK_ASSIGNMENT}</h4>
        <p>{SUB_TITLES.TASK_ASSIGNMENT}</p>
      </div>
      <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
        <div
          className="formGroup"
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: 0,
            marginBottom: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label
              style={{
                fontWeight: "500",
                fontSize: 14,
                marginTop: 6,
                marginRight: 8,
              }}
            >
              {LABELS.FROM_DATE}
            </label>
            <TxtRow
              type={"date"}
              id="fromDt"
              defaultValue={DateFunctions.getDate(
                "today",
                "from",
                "YYYY-MM-DD"
              )}
            />
          </div>

          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label
              style={{
                fontWeight: "500",
                fontSize: 14,
                marginTop: 6,
                marginRight: 8,
              }}
            >
              {LABELS.TO_DATE}
            </label>
            <TxtRow
              type={"date"}
              id="toDt"
              defaultValue={DateFunctions.getDate(
                "thismonth",
                "to",
                "YYYY-MM-DD"
              )}
            />
          </div>

          <div
            style={{
              display: "flex",
              padding: 10,
              marginTop: "0.3rem",
            }}
          >
            <Btn
              text={LABELS.LOAD}
              onClick={loadGrid}
              bgColor={COLORS.SAVE_GREEN}
            />
          </div>
        </div>
      </div>
      {mandatoryLoadResults.length > 0 && (
        <div className="mandatoryBox">
          <ul>
            {mandatoryLoadResults.map((m) => {
              return (
                <li>
                  <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <div className="grid excelGridWrapper">
        {!gridLoading &&
          (rows ? (
            <ExcelGrid
              id={"taskAssignmnet"}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={LABELS.TASK_ASSIGNMENT}
              onReload={reloadGrid}
              onAdd={onAdd}
            />
          ) : (
            <div className="flexRowCenter">
              <Loader />
            </div>
          ))}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + TITLES.TASK_ASSIGNMENT + ": " + selectedRow.taskName
              : "Add " + TITLES.TASK_ASSIGNMENT
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="flexColumn">
            <div className="formGroup  required">
              <label>
                {LABELS.ASSIGNED_TO} {<span>*</span>}
              </label>

              <AutoComplete
                list={users}
                childRef={usersRef}
                defaultValue={
                  selectedRow.assignedToId
                    ? {
                        id: selectedRow.assignedToId,
                        label: selectedRow.assignedTo,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup  ">
              <TxtRow
                id={"taskName"}
                label={LABELS.TASK_NAMES}
                defaultValue={selectedRow.id ? selectedRow.taskName : ""}
                type={"text"}
                required={true}
                disabled={isSubmit}
              />
            </div>

            <div className="formGroup ">
              <label>
                {LABELS.ACTIVE_STATUS}
                {/* <span>*</span> */}
              </label>
              <RadioBtn
                list={[
                  {
                    id: "true",
                    value: "true",
                    label: LABELS.ACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "Yes"
                      : true,
                    disabled: isSubmit,
                  },
                  {
                    id: "false",
                    value: "false",
                    label: LABELS.INACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "No"
                      : false,
                    disabled: isSubmit,
                  },
                ]}
                row={true}
                name={"activeStatus"}
                required={true}
                disabled={isSubmit}
              />
            </div>
            {/* mandatoryResults */}
            {mandatoryResults.length > 0 && (
              <div className="mandatoryBox">
                <ul>
                  {mandatoryResults.map((m) => {
                    return (
                      <li>
                        <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            <div className="formGroup submitBtnWrapper">
              <div className="flexbtnjustify">
                <Btn
                  text={LABELS.CANCEL}
                  bgColor={COLORS.RELOAD_EXPORT}
                  color={COLORS.RELOAD_EXPORT_TEXT}
                  onClick={() => {
                    setManageDialog(false);
                    setMandatoryResults([]);
                  }}
                  loading={isSubmit}
                />
                <Btn
                  text={LABELS.SAVE}
                  onClick={manageRecord}
                  loading={isSubmit}
                  bgColor={COLORS.SAVE_GREEN}
                />
              </div>
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};
export default withSnackbar(TaskAssignment);
